import React from 'react'
import { Drawer } from '@components/foundation/drawer/Drawer'
import { AppRoutes } from './components/AppRoutes'
import { DrawerTopHeader } from './components/DrawerTopHeader'
import { useAppDrawer } from './hooks/useAppDrawer'
import { useAppDrawerState } from './hooks/useAppDrawerState'
import { useAppErrorHandler } from './hooks/useAppErrorHandler'
import { useDrawerEventListener } from './hooks/useDrawerEventListener'

export const AppRouter: React.FC = () => {
  useDrawerEventListener()
  const { onClose, onNavigateBack } = useAppDrawer()
  const { isVisible, showHeader, hideCloseButton } = useAppDrawerState()

  useAppErrorHandler()

  return (
    <Drawer
      open={isVisible}
      hideCloseButton={!showHeader || hideCloseButton}
      onClose={onClose}
      topHeader={showHeader ? <DrawerTopHeader onNavigateBack={() => onNavigateBack?.()} /> : undefined}
    >
      <AppRoutes />
    </Drawer>
  )
}
